/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-object-type */
// 2) Third-party library imports
import {
    concat,
    get,
    isEqual,
    isUndefined,
    keyBy,
    merge,
    uniqWith,
    values,
} from 'lodash-es';
import {
    createAction,
    createSelector,
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit';

// 3) Local imports � Project-specific modules / types
import { PaymentBehaviourInsightsState, PaymentBehaviourInsightsActionTypes, PaymentBehaviourInsightsConfiguration } from './types';
import type { RootState } from '../storeTypes';

// 3d) Local imports � Utility functions / interfaces
import { DynamicObject, ResponseModalObject } from '../../utils/commonInterfaces';

const actionPrefix = 'payment';

// Type-safe initialState!
export const initialState: PaymentBehaviourInsightsState = {
    data: {
        CompanyConfigBehaviourInsights: [],
        ComparisonPeriod: null,
        EvaluationScheduleType: null,
        EvaluationTiming: null,
        EvaluationTimingDay: null,
        NextEvaluationDate: null
    },
    errorMessages: [],
    loading: false,
    saveLoading: false,
};

const paymentBehaviourInsightsSlice = createSlice({
    name: actionPrefix,
    initialState,
    reducers: {
        getPaymentBehaviourInsightsConfigRequestAction: (state) => {
            state.loading = true;
        },
        getPaymentBehaviourInsightsConfigSuccessAction: (
            state,
            action: PayloadAction<PaymentBehaviourInsightsConfiguration>
        ) => {
            state.loading = false;
            state.data = action.payload;
        },
        getPaymentBehaviourInsightsConfigErrorAction: (state) => {
            state.loading = false;
        },
        savePaymentBehaviourInsightsConfigRequestAction: {
            reducer: (
                state,
                action: PayloadAction<{
                    payload: any;
                    callback?: (response: ResponseModalObject) => void
                }>
            ) => {
                state.saveLoading = true;
            },
            prepare: (
                payload: any,
                callback?: (response: ResponseModalObject) => void
            ) => ({
                payload: {
                    payload,
                    callback
                }
            })
        },
        savePaymentBehaviourInsightsConfigResponseAction: (
            state
        ) => {
            state.saveLoading = false;
        }
    }
});

const { actions, reducer } = paymentBehaviourInsightsSlice;

// Actions
export const {
    getPaymentBehaviourInsightsConfigRequestAction,
    getPaymentBehaviourInsightsConfigSuccessAction,
    getPaymentBehaviourInsightsConfigErrorAction,
    savePaymentBehaviourInsightsConfigRequestAction,
    savePaymentBehaviourInsightsConfigResponseAction
} = actions;

// Reducer
export default reducer;